export const GET_ALL_SUCCESS = "GET_ALL_SUCCESS";
export const GET_ALL_FAILURE = "GET_ALL_FAILURE";
export const GET_ALL_ARTICLES_SUCCESS = "GET_ALL_ARTICLES_SUCCESS";
export const GET_ALL_ARTICLES_FAILURE = "GET_ALL_ARTICLES_FAILURE";
export const PUT_SUCCESS = "PUT_SUCCESS";
export const PUT_FAILURE = "PUT_FAILURE";